import {dataTestId} from '@hconnect/uikit'
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {useRestoreEquipment} from '../../hooks/upmEntityConfig/useRestoreEquipment'
import {useItemDetails} from '../../providers'

export const RestoreEquipmentPopup = () => {
  const {setEquipmentToRestore, equipmentToRestore} = useItemDetails()
  const equipmentText = equipmentToRestore?.text

  const handleClose = () => {
    setEquipmentToRestore(undefined)
  }

  const {mutate: restoreEquipment} = useRestoreEquipment()

  const {t} = useTranslation()

  const handleRestoreEquipment = () => {
    if (equipmentToRestore?.upmId === undefined) return
    restoreEquipment(equipmentToRestore?.upmId, {
      onSuccess: handleClose
    })
  }

  return (
    <Dialog open onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('plantSetup.departmentConfig.restoreEquipment')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('plantSetup.departmentConfig.restoreEquipmentConfirmation', {equipmentText})}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          {t('common.cancel')}
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          {...dataTestId('restore-equipment-btn')}
          onClick={handleRestoreEquipment}
        >
          {t('common.restore')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
